import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=38f52c48&"
import script from "./overview.ts?vue&type=script&lang=js&"
export * from "./overview.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports